// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-event-js": require("gatsby-module-loader?name=component---src-templates-event-js!/opt/build/repo/src/templates/event.js"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-gdpr-js": require("gatsby-module-loader?name=component---src-pages-gdpr-js!/opt/build/repo/src/pages/gdpr.js"),
  "component---src-pages-imprint-js": require("gatsby-module-loader?name=component---src-pages-imprint-js!/opt/build/repo/src/pages/imprint.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "events-2026-11-28.json": require("gatsby-module-loader?name=path---events-2026-11-28!/opt/build/repo/.cache/json/events-2026-11-28.json"),
  "events-2100-01-01.json": require("gatsby-module-loader?name=path---events-2100-01-01!/opt/build/repo/.cache/json/events-2100-01-01.json"),
  "events-2100-01-02.json": require("gatsby-module-loader?name=path---events-2100-01-02!/opt/build/repo/.cache/json/events-2100-01-02.json"),
  "events-2100-01-03.json": require("gatsby-module-loader?name=path---events-2100-01-03!/opt/build/repo/.cache/json/events-2100-01-03.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "gdpr.json": require("gatsby-module-loader?name=path---gdpr!/opt/build/repo/.cache/json/gdpr.json"),
  "imprint.json": require("gatsby-module-loader?name=path---imprint!/opt/build/repo/.cache/json/imprint.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js